export const SIGN_UP = 'sign-up/SIGN_UP';
export const SIGN_UP_PENDING = 'sign-up/SIGN_UP_PENDING';
export const SIGN_UP_REJECTED = 'sign-up/SIGN_UP_REJECTED';
export const SIGN_UP_FULFILLED = 'sign-up/SIGN_UP_FULFILLED';
